import { render, staticRenderFns } from "./recaptcha-v2.component.html?vue&type=template&id=c59bb95e&scoped=true&"
import script from "./recaptcha-v2.component.ts?vue&type=script&lang=ts&"
export * from "./recaptcha-v2.component.ts?vue&type=script&lang=ts&"
import style0 from "./recaptcha-v2.component.scss?vue&type=style&index=0&id=c59bb95e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59bb95e",
  null
  
)

export default component.exports